<template>
    <v-dialog v-model="dialog" scrollable max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" class="text-lowercase mr-4" dark small v-on="on">add hidden needs</v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6 text-pre-wrap">
                New advanced features needs for <span class="secondary--text">{{ set.item }}</span> set
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-row justify="center">
                            <v-col cols="12" sm="6" md="6">
                                <v-select dense color="primary"
                                    return-object
                                    label="segment" 
                                    v-model="segment"
                                    :items="segments" 
                                    item-text="segment.name" 
                                    item-value="segmentId" 
                                    :rules="[rules.required]">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field dense color="primary" label="Positioning tracker"
                                    v-model.number="positioning_tracker" name="positioning_tracker"
                                    :rules="[rules.required, rules.number]" type="text">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Power bank" v-model.number="power_bank"
                                    name="power_bank" :rules="[rules.required]" type="text">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Missed items warning"
                                    v-model.number="missed_items_warning" name="items_warning" :rules="[rules.required]"
                                    type="text">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Danger alarm" v-model.number="danger_alarm"
                                    name="danger_alarm" :rules="[rules.required]" type="text">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Fridge camera" v-model.number="fridge_camera"
                                    name="fridge_camera" :rules="[rules.required]" type="text">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Loss insurance" v-model.number="loss_insurance"
                                    name="loss_insurance" :rules="[rules.required]" type="text">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Environment friendly utilization"
                                    v-model.number="friendly_utilization" name="friendly_utilization"
                                    :rules="[rules.required]" type="text">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Charity profit sharing"
                                    v-model.number="profit_sharing" name="profit_sharing" :rules="[rules.required]"
                                    type="text">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Individual pictures"
                                    v-model.number="individual_pictures"
                                    name="individual_pictures"
                                    :rules="[rules.required]" type="text">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error--text">{{ error }}</v-row>
                <v-row justify="center" class="subtitle-2">{{ message }}</v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text class="text-capitalize" :disabled="!valid || Boolean(error)" @click="save">
                    Save
                </v-btn>
                <v-btn color="primary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'AddHiddenNeeds',
    props: ['set', 'round'],
    data() {
        return {
            dialog: false,
            error: '',
            message: '',
            valid: false,
            //props
            segment: null,
            positioning_tracker: 0,
            power_bank: 0,
            missed_items_warning: 0,
            danger_alarm: 0,
            fridge_camera: 0,
            loss_insurance: 0,
            friendly_utilization: 0,
            profit_sharing: 0,
            individual_pictures: 0,
            rules: {
                required: value => !!value || 'required field',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected a number',
            }
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        segments() {
            return this.$store.getters.market_segments;
        }
    },
    methods: {
        closeDialog() {
            this.dialog = false
            this.message = ''
            this.error = ''
            this.$refs.form.reset()
        },
        async save() {

            if (this.$refs.form.validate()) {

                /* console.log(this.segment)*/ 
                const hidden_need = {
                    gameId: this.set.value,
                    round: this.round,
                    segmentId: this.segment.segmentId,
                    segment_name: this.segment.segment.name,
                    positioning_need: this.positioning_tracker,
                    power_bank_need: this.power_bank,
                    missed_items_warning_need: this.missed_items_warning,
                    danger_alarm_need: this.danger_alarm,
                    fridge_camera_need: this.fridge_camera,
                    loss_insurance_need: this.loss_insurance,
                    friendly_utilization_need: this.friendly_utilization,
                    profit_sharing_need: this.profit_sharing,
                    individual_pictures_need: this.individual_pictures,
                }
                //console.log(hidden_need)
                try {
                    await this.$store.dispatch('addAF', hidden_need);
                    this.closeDialog();
                }
                catch (error) {
                    this.error = error.message
                }
            }
        },
    },
    async mounted() {

        if (this.segments.length < 1) {
            const obj = { gameId: this.set.value, round: this.round }
            await this.$store.dispatch('fetchMarketSegments', obj);
        }
    }
}
</script>